/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { ReactNode } from "react";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import { useStyles } from "./styles";

interface ScheduleDetailsSingleRowProps {
  title: string;
  content?: string;
  dataTypes?: ReactNode;
}

const ScheduleDetailsSingleRow = ({
  title,
  content,
  dataTypes
}: ScheduleDetailsSingleRowProps) => {
  const { singleRowCSS } = useStyles();

  return (
    <div css={css(singleRowCSS)}>
      <Typography
        variant="body2SemiBold"
        sx={{ color: colors.textPlaceholder }}
      >
        {title}:
      </Typography>

      {content && (
        <Typography
          variant="body2SemiBold"
          sx={{ color: colors.textSecondary, wordBreak: "break-word" }}
        >
          {content}
        </Typography>
      )}

      {dataTypes}
    </div>
  );
};

export default ScheduleDetailsSingleRow;
